/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver and constructor championship standings with podium view, points, and season comparison.`)
};

const es_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificaciones del campeonato de pilotos y constructores con vista de podio, puntos y comparación de temporada.`)
};

const de_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fahrer- und Konstrukteur-Meisterschaftstabellen mit Podiumsansicht, Punkten und Saisonvergleich.`)
};

const nl_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coureurs- en constructeurskampioenschapsklassement met podiumweergave, punten en seizoensvergelijking.`)
};

const fr_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classements du championnat des pilotes et constructeurs avec vue podium, points et comparaison de saison.`)
};

const it_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifiche del campionato piloti e costruttori con vista podio, punti e confronto stagionale.`)
};

const pt_br2_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificações do campeonato de pilotos e construtores com visão de pódio, pontos e comparação de temporada.`)
};

const pt_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificações do campeonato de pilotos e construtores com vista de pódio, pontos e comparação de época.`)
};

const ja_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表彰台ビュー、ポイント、シーズン比較を含むドライバーとコンストラクターの選手権順位表。`)
};

const zh_f1_home_card_standings_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`车手和车队锦标赛积分榜，含颁奖台视图、积分及赛季对比。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_card_standings_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_card_standings_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_card_standings_desc", locale)
	if (locale === "en") return en_f1_home_card_standings_desc(inputs)
	if (locale === "es") return es_f1_home_card_standings_desc(inputs)
	if (locale === "de") return de_f1_home_card_standings_desc(inputs)
	if (locale === "nl") return nl_f1_home_card_standings_desc(inputs)
	if (locale === "fr") return fr_f1_home_card_standings_desc(inputs)
	if (locale === "it") return it_f1_home_card_standings_desc(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_card_standings_desc(inputs)
	if (locale === "pt") return pt_f1_home_card_standings_desc(inputs)
	if (locale === "ja") return ja_f1_home_card_standings_desc(inputs)
	return zh_f1_home_card_standings_desc(inputs)
};